import { render, staticRenderFns } from "./CandidateDetailsMobile.vue?vue&type=template&id=3360d72c&"
import script from "./CandidateDetailsMobile.vue?vue&type=script&lang=js&"
export * from "./CandidateDetailsMobile.vue?vue&type=script&lang=js&"
import style0 from "./CandidateDetailsMobile.vue?vue&type=style&index=0&id=3360d72c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports